import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

let cachedPermissions = null;

export function useModulePermissions() {
  const [permissions, setPermissions] = useState(cachedPermissions || { is_admin: false, module_access: {} });
  const [loading, setLoading] = useState(!cachedPermissions);

  useEffect(() => {
    if (cachedPermissions) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    axios.get(API + '/user/module-access', { headers: { Authorization: 'Bearer ' + token } })
      .then(res => {
        cachedPermissions = res.data;
        setPermissions(res.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const canView = useCallback((module) => {
    if (permissions.is_admin) return true;
    return permissions.module_access?.[module]?.view ?? false;
  }, [permissions]);

  const canCreate = useCallback((module) => {
    if (permissions.is_admin) return true;
    return permissions.module_access?.[module]?.create ?? false;
  }, [permissions]);

  const canEdit = useCallback((module) => {
    if (permissions.is_admin) return true;
    return permissions.module_access?.[module]?.edit ?? false;
  }, [permissions]);

  const canDelete = useCallback((module) => {
    if (permissions.is_admin) return true;
    return permissions.module_access?.[module]?.delete ?? false;
  }, [permissions]);

  return { permissions, loading, canView, canCreate, canEdit, canDelete };
}

export function clearPermissionsCache() {
  cachedPermissions = null;
}
